import React, { useState, useEffect } from 'react'
import { Table, Flex } from 'antd'
import classes from './client.module.css'
import { useKehukpxxListQuery } from '../../store/DianShangYeWuApi'
import ClientInvoiceAdd from './ClientInvoiceAdd'
import ClientInvoiceEdit from './ClientInvoiceEdit'
function ClientInvoiceList(props) {
    const [invoiceInfo, setInvoiceInfo] = useState([])
    //客户发票抬头
    const { data: invoiceData, isSuccess: invoiceSuccess } = useKehukpxxListQuery({ khkpxx_kh_id: props.kh_id }, { skip: !props.kh_id, refetchOnMountOrArgChange: 1 })
    useEffect(() => {
        if (invoiceSuccess) {
            setInvoiceInfo(invoiceData.Result)
        }
    }, [invoiceData, invoiceSuccess])
    const columnsInvoice = [       
        {
            title: '单位名称',
            dataIndex: 'khkpxx_name',
            width: '20%',
            render:(text,record) => {
                return <ClientInvoiceEdit 
                            khkpxx_id={record.khkpxx_id} 
                            khkpxx_name={record.khkpxx_name} 
                            khkpxx_code={record.khkpxx_code} 
                            khkpxx_content={record.khkpxx_content} 
                            kh_id={props.kh_id} 
                            yh_id={props.yh_id} 
                            yh_name={props.yh_name} 
                            kh_name={props.kh_name} 
                            qy_id={props.qy_id} 
                            qy_name={props.qy_name} 
                            khkpxx_ctime={record.khkpxx_ctime}
                            khkpxx_update_time={record.khkpxx_update_time}
                            khkpxx_cname={record.khkpxx_cname}
                            khkpxx_update_uname={record.khkpxx_update_uname}
                            khkpxx_dizhi={record.khkpxx_dizhi}
                            khkpxx_khh={record.khkpxx_khh}
                            khkpxx_yhzh={record.khkpxx_yhzh}
                            khkpxx_dh={record.khkpxx_dh}
                        />
            }
        },
        {
            title: '单位税号',
            dataIndex: 'khkpxx_code',
            width: '20%',
        
        },                       
        {
            title: '地址',
            dataIndex: 'khkpxx_dizhi',
            width: '10%',
        
        },                       
        {
            title: '开户行',
            dataIndex: 'khkpxx_khh',
            width: '10%',
        
        },                       
        {
            title: '银行账号',
            dataIndex: 'khkpxx_yhzh',
            width: '10%',
        
        },                       
        {
            title: '电话',
            dataIndex: 'khkpxx_dh',
            width: '10%',
        
        },                       
        {
            title: '备注',
            dataIndex: 'khkpxx_content',
            width: '10%',        
        },      
    ]


    return (
        <>
            <Flex justify='space-between' align='center' style={{width:'1000px',marginTop:'10px'}}>
                <div style={{fontSize:'16px',fontWeight:'bold',marginTop:'10px',color:'#663300'}}>开票信息</div>
                <ClientInvoiceAdd 
                    kh_id={props.kh_id} 
                    yh_id={props.yh_id} 
                    yh_name={props.yh_name} 
                    kh_name={props.kh_name} 
                    qy_id={props.qy_id} 
                    qy_name={props.qy_name} 
                />
            </Flex>
            <Table 
                dataSource={invoiceInfo} 
                columns={columnsInvoice}
                className={classes.invoiceTable}
                size='small'
                bordered
                pagination={false}
                rowKey='khkpxx_id'
                style={{marginTop:'2px',width:'1000px'}}
                locale={{
                    emptyText: '暂无开票信息' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default ClientInvoiceList